import { z } from "zod";

export const QualioUser = z.object({
  id: z.number(),
  fullName: z.string(),
});
export type QualioUser = z.infer<typeof QualioUser>;
